import { RootStore } from '@app/models/RootStore'

export const selectionForDataset = (rootStore: RootStore, dataset: string) => {
  const hoveredLap =
    rootStore.hoveredDataset === dataset ? rootStore.hoveredLap : null
  const selectedLap =
    rootStore.selectedDataset === dataset ? rootStore.selectedLap : null

  return {
    outlinedXValue: rootStore.hoveredLap !== null ? hoveredLap : selectedLap,
    activeXValue: selectedLap,
  }
}

// based on npm parse-ms
const parseMilliseconds = (milliseconds: number) => {
  const roundTowardsZero = milliseconds > 0 ? Math.floor : Math.ceil

  return {
    days: roundTowardsZero(milliseconds / 86400000),
    hours: roundTowardsZero(milliseconds / 3600000) % 24,
    minutes: roundTowardsZero(milliseconds / 60000) % 60,
    seconds: roundTowardsZero(milliseconds / 1000) % 60,
    milliseconds: roundTowardsZero(milliseconds) % 1000,
    microseconds: roundTowardsZero(milliseconds * 1000) % 1000,
    nanoseconds: roundTowardsZero(milliseconds * 1e6) % 1000,
  }
}

export const padNumber = (n: number, characters: number) =>
  n.toString().padStart(characters, '0')

export const formatLap = (ms: number) => {
  const { minutes, seconds } = parseMilliseconds(ms)
  return `${padNumber(minutes, 2)}:${padNumber(seconds, 2)}`
}

export const formatLapPrecise = (ms: number) => {
  const { minutes, seconds, milliseconds } = parseMilliseconds(ms)
  return `${padNumber(minutes, 2)}:${padNumber(seconds, 2)}.${padNumber(
    milliseconds,
    3
  )}`
}
